import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import PageTitle from 'src/components/PageTitle';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import { Box, Button, TextField, Snackbar,Grid } from '@mui/material';
import { post } from 'src/services/httpClient.service';
import axios from 'axios';

const AddMetadata = ({ handleClose }) => {

    const [openDialog, setOpenDialog] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const APIURL = process.env.REACT_APP_BASE_API_URL;

  const [metadata, setMetadata] = useState({
    title:'',
    duration: '',
    language: '',
    year: '',
    month: '',
    day: '',
    director: '',
    writer: '',
    acting: '',
    award: '',
    details: '',
    price: '',
    purchaseDuration: '',
    tags: '',
    ratings: '',
    imdbRatings: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setMetadata((prevMetadata) => ({
      ...prevMetadata,
      [name]: value,
    }));
  };


  const onClose = () => {
    setOpenDialog(false);
  };

  const handleSnackbarClose = () => {
    setOpenSnackbar(false);
  };



  const handleSubmit = async () => {
    try {
      //await axios.post(`${process.env.REACT_APP_BASE_API_URL}${process.env.REACT_APP_VODMETADATA}`, metadata);
      await post(`${APIURL}/videoMetadata/add`, metadata);
      // Handle success
      console.log('Metadata added successfully');

      // Show success message
      setSnackbarMessage('Metadata added successfully');
      setOpenSnackbar(true);

      // Reset the form after submission
      setMetadata({
        title:'',
        duration: '',
        language: '',
        year: '',
        month: '',
        day: '',
        director: '',
        writer: '',
        acting: '',
        award: '',
        details: '',
        price: '',
        purchaseDuration: '',
        tags: '',
        ratings: '',
        imdbRatings: '',
      });

      // Close the dialog automatically after 3 seconds
      setTimeout(() => {
        handleClose(); // use parent dialog close
        setOpenSnackbar(false); // hide snackbar
      }, 3000);
    } catch (error) {
      console.error('Error adding metadata:', error);
      setSnackbarMessage('Error adding metadata. Please try again.');
      setOpenSnackbar(true);
    }
  };

  return (
    <>
      <Helmet>
        <title>Add Metadata</title>
      </Helmet>
     
      {/* <PageTitleWrapper>
        <PageTitle heading="Add Metadata" subHeading="Enter details for new metadata" handleClick={undefined} />
      </PageTitleWrapper> */}

        <Box sx={{ width: '100%', padding: '2px' }}>
        {/* Grid layout for adding metadata */}
        <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Title"
              name="title"
              value={metadata.title}
              onChange={handleChange}
            //   margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Duration"
              name="duration"
              value={metadata.duration}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Language"
              name="language"
              value={metadata.language}
              onChange={handleChange}
            //   margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Year"
              name="year"
              value={metadata.year}
              onChange={handleChange}
            //   margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Month"
              name="month"
              value={metadata.month}
              onChange={handleChange}
            //   margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Day"
              name="day"
              value={metadata.day}
              onChange={handleChange}
            //   margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Director"
              name="director"
              value={metadata.director}
              onChange={handleChange}
            //   margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Writer"
              name="writer"
              value={metadata.writer}
              onChange={handleChange}
            //   margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Acting"
              name="acting"
              value={metadata.acting}
              onChange={handleChange}
            //   margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Award"
              name="award"
              value={metadata.award}
              onChange={handleChange}
            //   margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Details"
              name="details"
              value={metadata.details}
              onChange={handleChange}
            //   margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Price"
              name="price"
              value={metadata.price}
              onChange={handleChange}
            //   margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Purchase Duration"
              name="purchaseDuration"
              value={metadata.purchaseDuration}
              onChange={handleChange}
            //   margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Tags"
              name="tags"
              value={metadata.tags}
              onChange={handleChange}
            //   margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="Ratings"
              name="ratings"
              value={metadata.ratings}
              onChange={handleChange}
            //   margin="normal"
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              label="IMDb Ratings"
              name="imdbRatings"
              value={metadata.imdbRatings}
              onChange={handleChange}
            //   margin="normal"
            />
          </Grid>
        </Grid>

        {/* Submit and Cancel buttons */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
        <Button
                    onClick={handleClose}
                    variant="outlined"
                    color="primary"
                    sx={{ marginRight: '10px' }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleSubmit}
                    variant="contained"
                    color="primary"
                  >
                    Submit
                  </Button>
        </Box>
      </Box>

        {/* Snackbar for success message */}
     <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
      />


      
 
    </>
  );
};

export default AddMetadata;
